<template>
  <div class="city-select" :class="{'disabled': disabled}">
    <div class="city-select-block" @click="toggle" v-if="value && value.name">{{value.name}}</div>
    <div class="city-select-block place-holder" @click="toggle" v-else>{{placeholder || "请选择"}}</div>
    <transition name="fade-white">
      <city-choose v-if="showCityChoose" @change="change" :list="options" :value="value"></city-choose>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.city-select {
  flex: 1 0 0;
  display: inline-block;
  height: 100%;
  &.disabled {
    pointer-events: none;
  }
}

.city-select {
  position: relative;
  font-size: $ucar_font_h4;
  line-height: 100px;
  text-align: right;
  padding-right: 40px;
  height: 100%;
  color: $ucar_font_color;
}

.city-select::after {
  position: absolute;
  right: 5px;
  top: 50%;
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  border-bottom: 2px solid $ucar_font_assist_color;
  border-right: 2px solid $ucar_font_assist_color;
  transform: translate3d(0, -50%, 0) rotate(-45deg);
  box-sizing: border-box;
}

.city-select.disabled::after {
  display: none;  
}

.place-holder {
  color: $ucar_font_assist_color;
}
</style>

<script>
import cityChoose from './city-choose'

export default {
  data () {
    return {
      showCityChoose: false
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {}
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'city-choose': cityChoose
  },
  watch: {
    showCityChoose (val) {
      setTimeout(() => {
        this.$emit('overflow-hidden', val)
      })
    }
  },
  methods: {
    change (val) {
      this.showCityChoose = false
      if (val) this.$emit('input', val)
    },
    toggle () {
      if (this.disabled) return
      this.showCityChoose = !this.showCityChoose
    }
  },
  destroyed () {
    this.$emit('overflow-hidden', false)
  }
}
</script>
